export default "__VITE_ASSET__DpWHO17L__"